"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const appointment_entity_1 = require("../consultation/appointment.entity");
const customer_entity_1 = require("../customers/customer.entity");
const interaction_log_entity_1 = require("../customers/interaction-log.entity");
const inventory_stock_entity_1 = require("../inventory/inventory-stock.entity");
const order_entity_1 = require("../orders/order.entity");
const service_ticket_entity_1 = require("../tickets/service-ticket.entity");
const ticket_evidence_entity_1 = require("../tickets/ticket-evidence.entity");
const dashboard_controller_1 = require("./dashboard.controller");
const dashboard_service_1 = require("./dashboard.service");
let DashboardModule = class DashboardModule {
};
exports.DashboardModule = DashboardModule;
exports.DashboardModule = DashboardModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [typeorm_1.TypeOrmModule.forFeature([order_entity_1.Order, service_ticket_entity_1.ServiceTicket, ticket_evidence_entity_1.TicketEvidenceLink, inventory_stock_entity_1.InventoryStock, customer_entity_1.Customer, appointment_entity_1.Appointment, interaction_log_entity_1.InteractionLog])],
        controllers: [dashboard_controller_1.DashboardController],
        providers: [dashboard_service_1.DashboardService],
    })
], DashboardModule);
